import { CacheProvider } from "@emotion/react";
import styled from "@emotion/styled";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Switch,
  TableCell,
  TableRow,
} from "@mui/material";
import MUIDataTable from "mui-datatables";
import React, { useContext, useEffect, useState } from "react";
import AddButton from "../../components/300/AddButton";
import BasicTable from "../../components/300/BasicTable";
import RankContext from "../../context/RankContext";
import useAuth from "../../hooks/useAuth";
import EditIcon from "@mui/icons-material/Edit";

import createCache from "@emotion/cache";
import { NavLink, useNavigate } from "react-router-dom";
import useAxiosPrivate from "./../../hooks/useAxiosPrivate";

const muiCache = createCache({
  key: "mui",
  prepend: true,
});
function Rank() {
  let navigate = useNavigate();
  let api = useAxiosPrivate();

  const { user } = useAuth();
  const rankContext = useContext(RankContext);
  const [modalState, setModalState] = useState({
    open: false,
    name: null,
    courseCode: null,
    disabled: null,
  });

  const handleClose = () => {
    setModalState({ ...modalState, open: false });
  };
  const handleOpen = (courseCode) => {
    let rank = rankContext.rankState.filter((course) => {
      return course.course_code === courseCode;
    })[0];
    // console.log(course);
    setModalState({
      academicTtile: rank.academicTtile,
      rankId: rank.id,
      open: true,
      disabled: rank.disabled,
    });
  };
  const handleDisable = () => {
    rankContext.rankDispatch({
      type: "disableRank",
      rankId: modalState.rankId,
    });
    handleClose();
  };

  const columnHead = [
    {
      label: "ID",
      name: "id",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      label: "Academic Title",
      name: "academic_type",
      options: {
        filter: true,
      },
    },
    {
      label: "Payment Rate",
      name: "payment_rate",
      options: {
        filter: true,
      },
    },

    {
      label: "Action",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div
              style={{ width: "100px", display: "flex", alignItems: "center" }}
            >
              {user.roles.includes(304) && (
                <EditIcon
                  color="primary"
                  onClick={() => {
                    navigate("editRank", {
                      state: { id: value },
                    });
                  }}
                />
              )}
              {/*<NavLink to={`/deleteCourse/${value}`}>*/}
              {user.roles.includes(305) && (
                <Switch
                  checked={
                    true
                    // !tableMeta.tableData.filter((row, index) => {
                    //        if (row.id == value) {
                    //          return true;
                    //        }
                    //        return false;
                    //      })[0].disable
                    //    }
                    //    onClick={() => {
                    //      handleOpen(value);
                    //    }
                  }
                />
              )}
              {tableMeta.tableData.filter((row) => {
                console.log(row.disable);
              })}
              {/*</NavLink>*/}
            </div>
          );
        },
      },
      name: "delete",
    },
  ];
  const options = {};

  let positions = rankContext.rankState.map((rank) => {
    return { ...rank, delete: rank.id };
  });
  const StyledMUIDataTable = styled(MUIDataTable)(({ theme }) => ({
    background: theme.palette.background.default,
  }));

  return (
    <>
      <CacheProvider value={muiCache}>
        <StyledMUIDataTable
          title={"Rank List"}
          data={positions}
          columns={columnHead}
          options={options}
        />
      </CacheProvider>

      <Dialog open={modalState.open} onClose={handleClose}>
        <DialogTitle id="alert-dialog-title">
          {modalState.disabled ? "Enable " : "Disable "}
          {modalState.name} ?
        </DialogTitle>
        <DialogContent>
          {modalState.disabled
            ? "Now you will be able to assign courses"
            : "once you disable it you won't be able to assign courses"}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} sx={{ color: "teritiary.darker" }}>
            cancel
          </Button>
          {/* <Button variant="outlined" color="secondary" onClick={handleDisable}>
            {modalState.disabled ? "Enable" : "Disable"}
          </Button> */}
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Rank;
